export const groupCommentByType = (arr, sortKey = null, sortOrder = "asc") => {
  const result = [];
  let buffer = [];
  const groupType = "notification";

  const sortBuffer = (buffer) => {
    if (!sortKey) return buffer;
    return [...buffer].sort((a, b) => {
      const valA = a[sortKey];
      const valB = b[sortKey];
      if (valA < valB) return sortOrder === "asc" ? -1 : 1;
      if (valA > valB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  };

  for (const item of arr) {
    if (item.is_notification) {
      buffer.push(item);
    } else {
      if (buffer.length) {
        result.push({
          type: "group",
          groupType,
          items: sortBuffer(buffer),
        });
        buffer = [];
      }
      result.push(item);
    }
  }

  // Push any remaining notifications at the end
  if (buffer.length) {
    result.push({
      type: "group",
      groupType,
      items: sortBuffer(buffer),
    });
  }

  return result;
};
